import { useEffect, useRef } from 'react';
import CountUp from 'react-countup';
import { Icon } from '@iconify/react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const BenefitsShowcase = () => {
  const trackRef = useRef(null);

  const cards = [
    {
      icon: (
        <Icon
          icon='streamline-ultimate:office-building-tall-2'
          width='50'
          className='text-yellow-400 mb-4'
        />
      ),
      value: 500,
      suffix: '+',
      text: 'Companies trust us',
      count: true,
    },
    {
      icon: (
        <Icon
          icon='icon-park-twotone:delivery'
          width='50'
          className='text-green-400 mb-4'
        />
      ),
      value: 93.7,
      suffix: '%',
      text: 'First time right delivery',
      count: true,
    },
    {
      icon: (
        <Icon
          icon='streamline-sharp:customer-support-1-remix'
          width='50'
          className='text-blue-400 mb-4'
        />
      ),
      value: '24/7',
      text: '24h / 7 support',
      count: false,
    },
    {
      icon: (
        <Icon
          icon='material-symbols:delivery-truck-speed-outline'
          width='50'
          className='text-red-400 mb-4'
        />
      ),
      value: 'Delivery',
      text: 'All vehicle types',
      count: false,
    },
  ];

  // Clone cards for seamless infinite scroll
  const extendedCards = [...cards, ...cards];

  useEffect(() => {
    AOS.init({ once: true, easing: 'ease-in-sine' });

    let animationFrameId;
    const track = trackRef.current;
    let x = 0;

    const speed = 1;

    const animate = () => {
      if (!track) return;
      x -= speed;
      const firstCardWidth =
        track.children[0].offsetWidth + parseInt(getComputedStyle(track).gap);
      if (Math.abs(x) >= firstCardWidth * cards.length) x = 0;
      track.style.transform = `translateX(${x}px)`;
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <section className='relative w-full bg-[#e1ebfd] py-6 sm:py-12 overflow-hidden'>
      <div
        className='w-full flex'
        ref={trackRef}
        style={{ gap: '2rem', willChange: 'transform' }}
      >
        {extendedCards.map((card, idx) => (
          <div
            key={idx}
            className='min-w-[14rem] sm:min-w-[18rem] md:min-w-[20rem] lg:min-w-[22rem] max-w-[22rem] p-3 sm:p-5 md:p-7 lg:p-8 text-center flex flex-col items-center bg-white rounded-xl shadow-lg hover:shadow-xl hover:scale-[1.05] transition-transform'
          >
            {card.icon}

            <h2 className='text-2xl sm:text-4xl md:text-5xl font-bold mb-2 sm:mb-3'>
              {card.count ? (
                <>
                  <CountUp
                    start={0}
                    end={Number(card.value)}
                    duration={2.5}
                    decimals={card.suffix === '%' ? 1 : 0}
                  />
                  {card.suffix}
                </>
              ) : (
                card.value
              )}
            </h2>

            <p className='text-xs sm:text-base md:text-lg'>{card.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BenefitsShowcase;

/*

 import { useEffect } from 'react';
 import CountUp from 'react-countup';
 import { FaBicycle, FaCar, FaTruck } from "react-icons/fa";
 import AOS from "aos";

 const Benefits = () => {
     useEffect(() => {
         AOS.init({
            easing: "ease-in-sine",
         });
     }, []);
     return (
         <div className='bg-gray-200 p-6'>
             <div className='grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 lg:gap-4 gap-10 w-[90%] mx-auto  '>
                 <div data-aos="fade-up" className='text-center hover:bg-gray-300 py-4 rounded-lg'
                     >
                     <h2 className="text-5xl font-semibold mb-3">
                         <CountUp
                             start={1}
                             end={500}
                             duration={2.75}
                             className="count-up" />+

                     </h2>
                     <p>Companies trust us</p>
                 </div>
                 <div data-aos="fade-up" className='text-center hover:bg-gray-300 py-4 rounded-lg'
                     >
                     <h2 className="text-5xl font-semibold mb-3">
                         <CountUp
                             start={1}
                             end={97.4}
                             duration={2.75}
                             className="count-up2" />%
                     </h2>
                     <p>First time right delivery</p>
                 </div>
                 <div data-aos="fade-up" className='text-center hover:bg-gray-300 py-4 rounded-lg'>
                     <h2 className="text-5xl font-semibold mb-3">
                         24/7
                     </h2>
                     <p>24h/7 support</p>
                 </div>
                 <div data-aos="fade-up" className='text-center hover:bg-gray-300 py-4 rounded-lg'>
                     <h2 className="text-5xl font-semibold flex justify-center gap-6 mb-3">
                         <FaBicycle />
                         <FaCar />
                         <FaTruck />
                     </h2>
                     <p>All vehicle types</p>
                 </div>
             </div>
         </div>
     );
 };

 export default Benefits;

 */
